import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BaseSessionService } from '../services/base-session.service';
import { SESSION_EXPIRED_MESSAGE } from '../services/token-refresh.service';


/** Guards a route behind a valid session; redirects to /login with redirectUrl. */
export const authGuard: CanActivateFn = (_route, state) => {
  const session = inject(BaseSessionService);
  const router = inject(Router);

  if (session.isTokenValid()) {
    return true;
  }

  // An expired token means the session ended: say so, and skip the Logout call.
  if (session.getSessionItem(BaseSessionService.KEY_AUTH_TOKEN)) {
    session.clearExpiredSession(SESSION_EXPIRED_MESSAGE);
  } else {
    session.logout();
  }

  return router.createUrlTree(['/login'], {
    queryParams: { redirectUrl: state.url }
  });
};
